import { publicApi } from "@/lib/api";

export interface EnquiryPayload {
  name: string;
  company: string;
  email: string;
  phone: string;
  message: string;
}

/**
 * Submit a Contact-page enquiry. Public — no auth. The backend stores the
 * enquiry and emails the race team (reply-to = the submitter).
 */
export async function submitEnquiry(payload: EnquiryPayload): Promise<{ success: boolean; message: string }> {
  const { data } = await publicApi.post<{ success: boolean; message: string }>("/microsite/enquiries", payload);
  return data;
}
